import { render, staticRenderFns } from "./rateDetail.vue?vue&type=template&id=96736a1c&scoped=true"
import script from "./rateDetail.vue?vue&type=script&lang=js"
export * from "./rateDetail.vue?vue&type=script&lang=js"
import style0 from "./rateDetail.vue?vue&type=style&index=0&id=96736a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96736a1c",
  null
  
)

export default component.exports